
import React, { useState, useEffect } from "react";
import CustomDropdown from '../components/Common/CustomDropdown'
import {raidTypes,getDriveQuantity,getDriveSize} from '../constants/raidCapacity'


const RaidCapacityCalculator = () => {
    // Your existing code here...
    const buttonClass = `sd-text-sm sd-h-10 sd-text-base sd-w-full sd-border sd-border-gray-300 sd-px-3 sd-bg-white`
    const dropDownClass = "sd-text-sm"
    const [raidType,setRaidType]=useState([])
    const [driveQuant,setDriveQuant]=useState([])
    const [driveSize,setDriveSize]=useState([])

    const handleRaidTypeChange = (event) =>{
        const raidType = event.ID; 
        if (raidType) {
            setRaidType(event); 
        }
    }
    const handleDriveQuantity = (event) =>{
        const raidType = event.ID; 
        if (raidType) {
            setDriveQuant(event); 
        }
    }
    const handleDriveSize = (event) =>{
        const raidType = event.ID; 
        if (raidType) {
            setDriveSize(event); 
        }
    }



    return (
        <section className="sd-relative">
            <div className="sd-container">
                <div className="sd-grid lg:sd-grid-cols-16 sd-grid-cols-8 sd-gap-4 sd-h-full">
                    <div className="sd-grid sd-grid-cols-[subgrid] sd-col-span-8 sd-grid-cols-8 lg:sd-min-h-[calc(100vh-48px)] sd-gap-4 sd-top-12 lg:sd-top-auto lg:sd-self-end lg:sd-sticky lg:sd-bottom-0 lg:sd-border-none sd-border-b">
                        <div className="navigation sd-col-span-4 lg:sd-border-r sd-list sd-py-8">
                            <span className="sd-uppercase sd-text-[13px] sd-titleText">Back to Home</span>
                        </div>
                        <div className="sd-col-span-4 lg:sd-col-span-3 lg:sd-col-start-5 sd-py-8">
                            <span className="sd-uppercase sd-text-[13px] sd-titleText"> RAID Capacity Calculator</span>
                        </div>
                    </div>
                    <div className="sd-col-span-8 lg:sd-col-span-6 lg:sd-col-start-9 sd-pt-8 sd-mb-[136px] sd-paratext">
                        <div>
                            <CustomDropdown
                                label="Raid Type"
                                name="Raid Type"
                                data={raidTypes}
                                limit={1000}
                                valueKey="VALUE"
                                labelKey="NAME"
                                buttonClass={buttonClass}
                                dropDownClass={dropDownClass}
                                defaultValue={raidTypes.filter((item) => item?.VALUE === raidType?.VALUE)[0]}
                                seletctText="Please Select Value"
                                handleChange={handleRaidTypeChange}
                                // hideColumn={columnsToHide}
                                // renameColumn={[{SP_NO: "Party Request Number"},{SP_STATUS : "Request Status"},{BIZ_DOMAIN: "Business Classification"},{CREATED_BY2: "Created By"},{CREATION_DATE: "Creation Date (GMT)"},{MODIFIED_DATE: "Modified Date (GMT)"}]}
                            />
                        </div>
                        <div>
                            <CustomDropdown
                                label="Drive Quantity"
                                name="Drive Quantity"
                                data={getDriveQuantity()}
                                limit={1000}
                                valueKey="VALUE"
                                labelKey="NAME"
                                buttonClass={buttonClass}
                                dropDownClass={dropDownClass}
                                defaultValue={getDriveQuantity().filter((item) => item?.VALUE === driveQuant?.VALUE)[0]}
                                seletctText="Please Select Value"
                                handleChange={handleDriveQuantity}
                                // hideColumn={columnsToHide}
                                // renameColumn={[{SP_NO: "Party Request Number"},{SP_STATUS : "Request Status"},{BIZ_DOMAIN: "Business Classification"},{CREATED_BY2: "Created By"},{CREATION_DATE: "Creation Date (GMT)"},{MODIFIED_DATE: "Modified Date (GMT)"}]}
                            />
                        </div>
                        <div>
                            <CustomDropdown
                                label="Drive Size"
                                name="Drive Size"
                                data={getDriveSize()}
                                limit={1000}
                                valueKey="VALUE"
                                labelKey="NAME"
                                buttonClass={buttonClass}
                                dropDownClass={dropDownClass}
                                defaultValue={getDriveSize().filter((item) => item?.VALUE === driveSize?.VALUE)[0]}
                                seletctText="Please Select Value"
                                handleChange={handleDriveSize}
                                // hideColumn={columnsToHide}
                                // renameColumn={[{SP_NO: "Party Request Number"},{SP_STATUS : "Request Status"},{BIZ_DOMAIN: "Business Classification"},{CREATED_BY2: "Created By"},{CREATION_DATE: "Creation Date (GMT)"},{MODIFIED_DATE: "Modified Date (GMT)"}]}
                            />
                        </div>
                        <div>
                            <button className="sd-mt-2 sd-mb-6 sd-py-3 sd-px-10 sd-text-base sd-bg-black sd-text-white sd-border sd-border-black hover:sd-bg-grey-4 hover:sd-border-grey-4 sd-w-full sm:sd-w-auto">
                                Calculate
                            </button>
                        </div>
                        <div className="sd-border-b">
                                <p className="sd-font-bold">Raw Available Capacity -</p>
                        </div>
                        <div className="sd-mt-2">
                                <p className="sd-font-bold">Available For Storage -</p>
                        </div>
                        <div >
                                <p className="sd-font-bold">Used for Redundancy -</p>
                        </div>
                        <div>
                            <p className="sd-text-blue-400 sd-mt-2 hover:sd-underline"><a href="https://www.westerndigital.com/products?filterByUseCaseName=RAID" target="_blank">Explore RAID products</a></p>
                        </div>
                        <div className="sd-text-sm">
                            <p>1. This RAID Capacity Calculator is provided for illustrative purposes only. Capacity is calculated based on parameters selected in the tool. Please refer to individual device specifications to confirm RAID support, drive quantity allowed, and capacity support. 1GB = 1 billion bytes and 1TB = 1 trillion bytes. Actual user capacity may be less depending on operating environment.</p>
                            <p>2. To achieve optimal RAID capacity and performance, we advise using disks with the same capacity in your array. Using different-sized drives will result in wasted, unused space for the larger capacity drives. This does not apply for JBOD/JBOF setups since the drives function independently of each other.</p>
                        </div>
            
                    </div>

                </div>
            </div>
            
        </section>
    );
};

export default RaidCapacityCalculator;